export type Role = 'admin' | 'manager' | 'cashier';

export const DISCOUNT_LIMITS: Record<Role, number> = {
  cashier: 30,
  manager: 50,
  admin: 100,
};

export const validateDiscount = (discount: number, role: Role): { isValid: boolean; maxAllowed: number } => {
  const maxAllowed = DISCOUNT_LIMITS[role];
  
  if (discount > maxAllowed) {
    return {
      isValid: false,
      maxAllowed
    };
  }
  
  return {
    isValid: true,
    maxAllowed
  };
};

export const getDiscountLimitForRole = (role: Role): number => {
  return DISCOUNT_LIMITS[role];
};

export const getDiscountValidation = (discountValue: number, currentRole: Role) => {
  const validation = validateDiscount(discountValue, currentRole);
  const maxDiscountAllowed = getDiscountLimitForRole(currentRole);
  
  return { validation, maxDiscountAllowed };
};
